import type { PageAction } from "@octopusdeploy/design-system-components";
export function createGenerateAnnotationsPageAction(onClick: () => void): PageAction {
    return {
        type: "button",
        label: "Generate Scoping Annotations",
        buttonType: "secondary",
        onClick,
    };
}
